import * as Yup from 'yup';
import { yupToFormErrors } from 'formik';
import { SlackDataType } from '@mm/state/model/CampaignsModel';
import ConnectionModel from '@mm/state/model/ConnectionModel';

const validationSchema = Yup.object().shape({
  audienceId: Yup.string().trim().required('Audience Required'),
  slackParams: Yup.object().shape({
    accessTokenId: Yup.string().trim().required('Workspace Required'),
  }),
  data: Yup.object().shape({
    listId: Yup.string().trim().required('Channel Required'),
    messageInfo: Yup.object().shape({
      content: Yup.string().trim().required('Message Required'),
    }),
  }),
});

const validate = () => async (values: ConnectionModel) => {
  let errors = {};
  try {
    await validationSchema.validate(values, {
      abortEarly: false,
    });
  } catch (e) {
    errors = yupToFormErrors(e);
  }
  return errors;
};

const SlackNotificationHelper = { validate };

export default SlackNotificationHelper;
